import { LoggingService } from '@instinet-analytics/core-lib';
import { LogLevel } from '@instinet-analytics/core-lib';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyData = any;

export function buildLoggerForStore(stateName: string) {
    const ret = (
        loggingService: LoggingService,
        storeFunctionName: string,
        data?: AnyData
    ) => {
        logDebugForStore(loggingService, stateName, storeFunctionName, data);
    };

    ret.warn = (
        loggingService: LoggingService,
        thunkName: string,
        data?: AnyData
    ) => {
        logWarnForStore(loggingService, stateName, thunkName, data);
    };

    return ret;
}

export function logDebugForStore(
    loggingService: LoggingService,
    stateName: string,
    storeFunctionName: string,
    data: AnyData
) {
    loggingService.debug('store', `${stateName}|${storeFunctionName}`, data);
}

export function logWarnForStore(
    loggingService: LoggingService,
    stateName: string,
    storeFunctionName: string,
    data: AnyData
) {
    loggingService.warn('store', `${stateName}|${storeFunctionName}`, data);
}

export function logForStore(
    loggingService: LoggingService,
    level: LogLevel,
    stateName: string,
    storeFunctionName: string,
    data: AnyData
) {
    loggingService.logMessage(
        level,
        'store',
        `${stateName}|${storeFunctionName}`,
        data
    );
}
